import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';
export const EditablePlugin = ({ disabled }) => {
    const [editor] = useLexicalComposerContext();
    useEffect(() => {
        editor.setEditable(!disabled);
    }, [editor, disabled]);
    return null;
};
